import React, { Component} from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import axios from 'axios';
import WriteCategory from './writeCategory';
import * as constants from '../config/constants';
import TextField from '@material-ui/core/TextField'

const CustomTableCell = withStyles(theme => ({
	head: {
		backgroundColor: theme.palette.grey[200],
		color: theme.palette.common.black,
		textTransform: 'uppercase',
		fontWeight: 700
	},
	body: {
		fontSize: 14,
	},
}))(TableCell);

const styles = theme => ({
	button: {
		margin: theme.spacing.unit,
		
	},
	table: {
		minWidth: 700,

	},
	root: {
		width: '100%',
		marginTop: theme.spacing.unit * 3,
		overflowX: 'auto',
	}
});

class Category extends Component {
	constructor() {
		super();
		this.state = {
			categories: [],
			currentCategory: null,
			dialog: false,
			searchTerm : ''
		}
		this.handleWriteCategory = this.handleWriteCategory.bind(this);
		this.createCB = this.createCB.bind(this);
		this.handleSearch = this.handleSearch.bind(this);
	}
	createCB(category) {
		let copiedStates = Object.assign({}, this.state);
		if(copiedStates.currentCategory) {
			copiedStates.categories.map((c, i) => {
				console.log("c, category", c, category);
				if(c.id === category.id) {
					copiedStates.categories[i] = category;
					copiedStates.categories[i].visible = true;
				}
			});
			copiedStates.currentCategory = null;
		} else {
			category.visible = true;
			copiedStates.categories.push(category);
		}
		copiedStates.dialog = false;
		this.setState(copiedStates);
	}
	handleWriteCategory = (event, category) => {
		let copiedStates = Object.assign({}, this.state);
		copiedStates.dialog = !copiedStates.dialog;
		copiedStates.currentCategory = category ? category : null;
		this.setState(copiedStates);
	}
	componentDidMount() {
		let copiedStates = Object.assign({},this.state);
		let that = this;
		axios.get(constants.API_BASE_URL + "category")
		.then(function(response){
			copiedStates.categories = response.data.details;
			response.data.details.map(c => {
				c.visible = true;
			});
			that.setState(copiedStates);
		})
		.catch(function(error){
			alert(error);
		})
	}
	handleSearch(event) {
		let copiedStates = Object.assign({}, this.state);
		if(event.target.value !== '') {
			let	regex = new RegExp((event.target.value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')) , 'ig');
			for(var key in copiedStates.categories) {
				if((copiedStates.categories[key].name.search(regex) > -1)
					|| (copiedStates.categories[key].name.search(regex) > -1)
					|| (copiedStates.categories[key].type.search(regex) > -1)){
					console.log("Matched"+ copiedStates.categories[key].name);
				copiedStates.categories[key].visible = true;	
			}
			else {
				copiedStates.categories[key].visible = false;
			}
		}
	} else {
		copiedStates.categories.map(c => {
			c.visible = true;
		});
	}
	copiedStates.searchTerm = event.target.value;
	this.setState(copiedStates);
}
render = () => {
	const { classes } = this.props;
	let { categories } = this.state;
	let categoryRows = [];
	categories.map((category, i) => {
		if(category.visible === true){
			categoryRows.push(
				<TableRow>
				<TableCell>
				{categories[i].name}
				</TableCell>
				<TableCell>
				{categories[i].type}
				</TableCell>
				<TableCell>
				<IconButton onClick={(event) => this.handleWriteCategory(event, category)} >
				<EditIcon />
				</IconButton>
				</TableCell>
				<TableCell>
				<IconButton>
				<DeleteIcon />
				</IconButton>
				</TableCell>
				</TableRow>
				);
		}
	});

	return(
		<div>

		<Button style={{
			position: 'fixed',
			bottom: '20px',
			right: '15px'
		}}
		variant="fab" color="primary" aria-label="add"
		className={classes.button}
		onClick={this.handleWriteCategory}>
		<AddIcon />
		</Button>

		<WriteCategory
		open={this.state.dialog}
		closeCB={this.handleWriteCategory}
		createCB={this.createCB}
		currentCategory={this.state.currentCategory}
		/>
		
		<Paper className={classes.root}>
		<div style={{
			padding: '15px',
			width: '100%'
		}}>
		<Typography variant="title" style={{
			textTransform: 'uppercase',
			float: 'left'
		}} >Category</Typography>
		<TextField
		style ={{
			float: 'right'
		}}
		id="searchTerm"
		name="searchTerm"
		placeholder="Search"
		value={this.state.searchTerm}
		onChange={this.handleSearch}
		className={classes.textField}
		InputLabelProps={{
			shrink: true,
		}}
		margin="normal"
		/>
		</div>
		<div style={{
				clear:'both'
			}}></div>
		<div style={{
			overflowX: "auto"
		}}>

		<Table className={classes.table}>
		<TableHead>
		<TableRow>
		<CustomTableCell>Name</CustomTableCell>
		<CustomTableCell>Type</CustomTableCell>
		<CustomTableCell>Edit</CustomTableCell>
		<CustomTableCell>Delete</CustomTableCell>
		</TableRow>
		</TableHead>
		<TableBody>
		{categoryRows}
		</TableBody>
		</Table>
		</div>
		</Paper>

		</div>
		)
}
}
Category.propTypes = {
	classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Category);


// WEBPACK FOOTER //
// ./src/category/category.js